import React, { useState } from 'react';
import Header from "../../components/Header";
import StarBackground from "../../components/StarBackground";
import Timeline from "../../components/Timeline";
import ExeCore from "../../components/ExeCore";
import Controls from "../../components/Controls";
import Planet from "../../components/Planet";
import Character from "../../components/Character";
import {useNavigate} from "react-router-dom";
import config from './syllablesConfig';


export default function Syllables() {
    // Mock recorder implementation for testing
    const [isRecording, setIsRecording] = useState(false);

    const startRecording = () => {
        setIsRecording(true);
    };

    const stopRecording = () => {
        setIsRecording(false);
    };

   const navigate = useNavigate();

    const handleValidate = () => {
        navigate('/exercise/syllables/main/1');
    }

    return (
        <div style={{
            height: '100vh',
            overflow: 'hidden',
            position: 'relative'
        }}>
            <Header color={config.headerColor}/>
            <StarBackground imagePath={config.planetBackground} />
            <Timeline current={0} total={config.totalLevels || 6} />

            {/* Opaque white background wrapper */}
            <div style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                borderRadius: '20px',
                padding: '20px',
                backdropFilter: 'blur(10px)',
                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)'
            }}>
                <ExeCore image={config.testImage} size={config.marsSize} />
            </div>

            <Controls
                colors={config.controlColors}
                onRepeat={() => console.log('Repeat')} // This prop is not currently used by Controls.js
                onStartRecording={startRecording} // Pass the explicit startRecording function
                onStopRecording={stopRecording}   // Pass the explicit stopRecording function
                onValidate={handleValidate}
                context={'1'} //Sostituire con test
                recording={isRecording} // Pass isRecording for the microphone visual feedback
                disableUpload={true}
            />
            <Planet image={config.planetImage} />
            <Character name="Mars" position='left' isActive={false} />
            <Character
                name={config.character}
                position='right'
                isActive={false}
            />
        </div>
    );
}
